// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance {
  z-index: 99999;
  position: absolute;
  inset: 0;
}

.maintenance a {
  font-family: Helvetica, sans-serif;
}

.maintenance-content {
  width: 650px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Maintenance/styles/Maintenance.css","webpack://./services/frontend/app/pages/Maintenance/styles/Maintenance.css"],"names":[],"mappings":"AADA;ECEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".maintenance {\n    position: absolute;\n    inset: 0;\n    z-index: 99999;\n}\n\n  .maintenance a {\n    font-family: Helvetica, sans-serif;\n  }\n\n.maintenance-content {\n  width: 650px;\n}\n",".maintenance {\n  z-index: 99999;\n  position: absolute;\n  inset: 0;\n}\n\n.maintenance a {\n  font-family: Helvetica, sans-serif;\n}\n\n.maintenance-content {\n  width: 650px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
